export default __webpack_public_path__ + "static/media/frame7.542de00b.png";